/**
 * @fileoverview GET handler for the "/decisioning_studio_agents/:app_group_id/:dsa_id/launch_validation" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsAppGroupIdDsaIdLaunchValidation } from "./constants";
import type { GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult } from "./types";
import { isGetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult } from "./validators";

export const getDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidation = reactQueryFetcherAdapter(
  decisioningStudioAgentsAppGroupIdDsaIdLaunchValidation,
  (
    signal: AbortSignal,
    appGroupId: string,
    dsaId: string
  ): Promise<GetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult> => {
    return fetch(
      `/decisioning_studio_agents/${appGroupId}/${dsaId}/launch_validation`,
      "GET",
      undefined,
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetDecisioningStudioAgentsAppGroupIdDsaIdLaunchValidationResult
);
